<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Row :gutter="32">
                <Col span="24">
                    <Card :bordered="false" dis-hover v-if="detail.status === 5">
                        <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 打款信息</template>
                        <DescriptionList class="show-description-title" title="" :col="4"  layout="vertical">
                            <Description term="打款金额：">
                                <Tag color="green">{{detail.pay_money}}</Tag>
                            </Description>
                            <Description term="打款时间：">
                                {{detail.pay_time}}
                            </Description>
                            <Description term="收款账号：">
                                {{detail.pay_account ?? '-'}}
                            </Description>
                            <Description term="打款人：">
                                {{detail.draw_name ?? '-'}}
                            </Description>
                        </DescriptionList>
                        <DescriptionList class="show-description-title" title="" :col="1"  layout="vertical">
                            <Description term="打款凭证">
                                <div class="uploads">
                                    <div class="upload-images" v-for="(item,index) in detail.pay_image" :key="index" @click.stop="">
                                        <img :src="site_url + item">
                                        <div class="show" @click.stop="PhotoView(site_url + item)">预览</div>
                                    </div>
                                </div>
                            </Description>
                        </DescriptionList>
                    </Card>
                    <Card :bordered="false" dis-hover>
                        <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 报销信息</template>
                        <DescriptionList class="show-description-title" title="" :col="3"  layout="vertical">
                            <Description term="报销进度：">
                                <Badge v-if="detail.status === 1" color="blue" :text="detail.status_name" />
                                <Badge v-else-if="detail.status === 3" color="orange" :text="detail.status_name" />
                                <Badge v-else-if="detail.status === 5" color="green" :text="detail.status_name" />
                                <Badge v-else-if="detail.status === 4 || detail.status === 2" color="red" :text="detail.status_name" />
                                <Badge v-else color="#999999" text="其他" />
                            </Description>
                            <Description term="报销金额：">
                                <Tag color="blue">{{detail.money}}</Tag>
                            </Description>
                            <Description term="报销编号：">
                                {{detail.sn}}
                            </Description>
                            <Description term="报销类型：">
                                {{detail.type_name}}
                            </Description>
                            <Description term="收款账号：">
                                {{detail.account ?? '-'}}
                            </Description>
                            <Description term="申请人：">
                                {{detail.apply_name}}
                            </Description>
                            <Description term="申请时间：">
                                {{detail.apply_time}}
                            </Description>
                            <Description term="审批人：" v-if="detail.status > 2">
                                {{detail.auditor_name}}
                            </Description>
                            <Description term="审批时间：" v-if="detail.status > 2">
                                {{detail.auditor_time}}
                            </Description>
                            <Description term="驳回时间：" v-if="detail.status ===4 || detail.status ===2">
                                {{detail.reject_time}}
                            </Description>
                            <Description term="驳回原因：" v-if="detail.status ===4 || detail.status ===2">
                                {{detail.reject_remark}}
                            </Description>

                        </DescriptionList>
                        <DescriptionList class="show-description-title" title="" :col="1"  layout="vertical">
                            <Description term="报销凭证">
                                <div class="uploads">
                                    <div class="upload-images" v-for="(item,index) in detail.image" :key="index" @click.stop="">
                                        <img :src="site_url + item">
                                        <div class="show" @click.stop="PhotoView(site_url + item)">预览</div>
                                    </div>
                                </div>
                            </Description>
                        </DescriptionList>
                        <DescriptionList class="show-description-title" title="" :col="1"  layout="vertical" v-if="detail.remark">
                            <Description term="备注信息：">
                                {{detail.remark}}
                            </Description>
                        </DescriptionList>
                    </Card>
                </Col>
            </Row>

            <!-- 预览图片 -->
            <Modal
                v-model="is_view_box"
                title="预览"
                :width="840"
                :mask-closable="true"
                :footer-hide="true"
                @on-cancel="PhotoViewClose()">
                <div class="flex-image-box">
                    <img :src="view_url" class="flex-image-box-show">
                </div>
            </Modal>
        </div>
    </Drawer>
</template>

<script>

import {getExpenseDetail} from "@/apis/expense";

export default {
    name: 'ExpendShow',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '支出详情',
            isBox : false,
            detail: [],
            site_url : this.$siteApi,
            is_view_box : false,
            view_url : ''
        }
    },
    methods: {
        /**
         功能：图片预览
         time: 2025-17-15 10:17:00
         **/
        PhotoView(url){
            if(url){
                this.view_url = url;
                this.is_view_box = true;
            }
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        PhotoViewClose(){
            this.is_view_box = false;
            this.view_url = '';
        },

        /**
         功能：
         time: 2025/12/17 16:04
         **/
        GetDetail(id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getExpenseDetail(id).then(e => {
                that.detail = e.data;
            })
        },
        /**
         功能：
         time: 2025/12/17 10:47
         **/
        show(id){
            this.isBox = true;
            if(id){
                this.GetDetail(id);
            }
        },
        /**
         功能：
         time: 2025/12/20 11:54
         **/
        FormReset(){
            this.isBox = false;
            this.detail = [];
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
